import React from "react";
import ToggleButton from "../../../CoreComponents/ToggleButton";
import { priceWithCommission } from "../variantPrice";

function VariantFields({ value, onChange }) {
  return (
    <>
    <div className="col-lg-6">
      <div className="form-group">
        <label className="text-black font-w600">
          Variant/Portion <span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="name"
          placeholder="Name"
          value={value.name}
          onChange={(e) =>
            onChange({
              ...value,
              name: e.target.value,
            })
          }
        />
      </div>
    </div>

    <div className="col-lg-6">
      <div className="form-group">
        <label className="text-black font-w600">
          Food Type <span className="required">*</span>
        </label>
        <select
          value={
            value.type || value.food_type || ""
          }
          className="form-control form-control-lg"
          onChange={(e) =>
            onChange({
              ...value,
              type: e.target.value,
              food_type: e.target.value,
            })
          }
        >
          <option value={""}>Select type</option>
          <option value={"vegetarian"}>Vegetarian</option>
          <option value={"non-vegetarian"}>Non-vegetarian</option>
          <option value={"eggetarian"}>Eggetarian</option>
        </select>
      </div>
    </div>

    <div className="col-lg-6">
      <div className="form-group">
        <label className="text-black font-w600">
          Retail Price <span className="required">*</span> (
          {priceWithCommission(
            value.rate,
            value?.commission_rate,
          )}
          )
        </label>
        <input
          type="number"
          className="form-control"
          placeholder="Rate"
          name="rate"
          onKeyDown={(evt) =>
            ((evt.key === "e" || evt.key === "-") &&
              evt.preventDefault()) ||
            (evt.key === "E" && evt.preventDefault())
          }
          onWheelCapture={(e) => {
            e.target.blur();
          }}
          value={value.rate}
          onChange={(e) =>
            onChange({
              ...value,
              rate: e.target.value,
            })
          }
        />
      </div>
    </div>

    <div className="col-lg-6">
      <div className="form-group">
        <label className="text-black font-w600">
          Offer Price (
          {priceWithCommission(
            value.offer_rate,
            value?.commission_rate,
          )}
          )
        </label>
        <input
          type="number"
          className="form-control"
          placeholder="Rate"
          name="rate"
          onKeyDown={(evt) =>
            ((evt.key === "e" || evt.key === "-") &&
              evt.preventDefault()) ||
            (evt.key === "E" && evt.preventDefault())
          }
          onWheelCapture={(e) => {
            e.target.blur();
          }}
          value={value.offer_rate}
          onChange={(e) =>
            onChange({
              ...value,
              offer_rate: e.target.value,
            })
          }
        />
      </div>
    </div>

    <div className="col-lg-6">
      <div className="form-group">
        <label className="text-black font-w600">
          Offer Enabled ?
        </label>
        <ToggleButton
          inactiveLabel={""}
          activeLabel={""}
          colors={{
            activeThumb: {
              base: "rgb(27 255 10)",
            },
            inactiveThumb: {
              base: "#ED3833",
            },
          }}
          value={value.offer_enabled}
          checked={value.offer_enabled}
          thumbStyle={{ borderradius: 5 }}
          trackStyle={{ borderradius: 5 }}
          onToggle={(e) => {
            onChange({
              ...value,
              offer_enabled: !e,
            });
          }}
        />
      </div>
    </div>

    <div className="col-lg-6">
      <div className="form-group">
        <label className="text-black font-w600">
          Order limit
        </label>
        <input
          type="number"
          className="form-control"
          name="order_limit"
          placeholder="order limit"
          value={value.order_limit}
          onChange={(e) =>
            onChange({
              ...value,
              order_limit: e.target.value,
            })
          }
        />
      </div>
    </div>

    <div className="col-lg-6">
      <div className="form-group">
        <label className="text-black font-w600">
          Extra Commission
        </label>
        <input
          type="number"
          className="form-control"
          name="commission_rate"
          placeholder="extra commission"
          value={value?.commission_rate}
          onChange={(e) =>
            onChange({
              ...value,
              commission_rate: e.target.value,
            })
          }
        />
      </div>
    </div>
    </>
  );
}

export default VariantFields;
